import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37e8aa54&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=37e8aa54&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e8aa54",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/bets/index.vue
// module id = jYYE
// module chunks = 0